module.exports = __webpack_public_path__ + "img/answer-info-icon.1e721344.png";